module.exports = __webpack_public_path__ + "static/media/ABE Level 4 & 5 Bus Man, HR and Marketing Booklet [final].40bbf49f.pdf";